import type { AzureUserProfile } from "@/modules/userProfile/types/AzureUserProfile";
import type { UserProfile } from "@/modules/userProfile/types/UserProfile";

// aadObjectId to dummy test maersk UID map
const TEST_USERS_MAP: Map<string, string> = new Map([
  ["a45915ac-b8dd-48f8-8a65-03c28e508d89", "CDA001"],
  ["1abee51b-25ed-4a97-9a7c-3b4e1c25b230", "CDA002"],
  ["5261d984-55cc-4f8d-b7f4-8330c605d340", "TST001"],
  ["913dbde5-6da2-4a93-a7a0-8b6eee01c982", "TST002"],
  ["0e9eefc4-48ea-4dd9-8a7f-bebbf5ab05cb", "TST003"],
  ["042cecd3-2a2f-418b-9f6e-e9c71df37ca7", "TST004"],
  ["1f1411d3-455b-4fce-8e05-a15d599dfdbf", "TST005"]
]);

const BACKUP_TEST_ID = "FTU001";

export function fromAzureUserProfile(userProfileResponse: AzureUserProfile): UserProfile {
  const mappedEmployeeId = userProfileResponse.employeeId
    ? userProfileResponse.employeeId
    : getMaerskUidByAadObjectId(userProfileResponse.id);

  return {
    id: userProfileResponse.id,
    userId: mappedEmployeeId,
    firstname: userProfileResponse.givenName,
    lastname: userProfileResponse.surname,
    fullName: userProfileResponse.displayName,
    mail: userProfileResponse.mail,
    jobTitle: userProfileResponse.jobTitle,
    company: userProfileResponse.companyName,
    department: userProfileResponse.department,
    officeLocation: userProfileResponse.officeLocation,
    country: userProfileResponse.country,
    roles: userProfileResponse.roles || [],
    userGroupMemberships: userProfileResponse.userGroupMemberships || []
  };
}

export function getMaerskUidByAadObjectId(aadObjectId: string): string {
  return TEST_USERS_MAP.get(aadObjectId) || BACKUP_TEST_ID;
}

export default {
  fromAzureUserProfile,
  getMaerskUidByAadObjectId
};
